<script>
import _ from 'lodash'
import { debugOptionsComputed } from '@state/helpers'

export default {
  data() {
    return {
      isDebugModeOn: false,
    }
  },
  computed: {
    ...debugOptionsComputed,
    isDebugOptionsEmpty() {
      return _.isEmpty(this.debugOptions)
    },
  },
  methods: {
    setDebugOptions(debugOptions) {
      const newDebugOptions = {
        ...this.debugOptions,
        [this.$route.name]: {
          ...this.debugOptions[this.$route.name],
          ...debugOptions,
        },
      }
      this.$store.commit('debugOptions/SET_DEBUG_OPTIONS', newDebugOptions)
    },
  },
}
</script>

<template>
  <div>
    <template v-if="!isDebugOptionsEmpty">
      <div v-if="!isDebugModeOn" :class="$style.openDebugMode" @click="isDebugModeOn = true">Open Debug Mode</div>
      <div v-if="isDebugModeOn" :class="$style.openDebugMode" @click="isDebugModeOn = false">Close Debug Mode</div>
      <div v-if="isDebugModeOn" :class="$style.debugModeWrapper"></div>
      <div v-if="isDebugModeOn" :class="$style.debugOptionsContainer">
        <span
          v-for="(debugOption, debugKey) in debugOptions[this.$route.name]"
          :key="debugKey"
          @click="setDebugOptions({ [debugKey]: !debugOption })">
          {{ _.startCase(debugKey) }} : {{ debugOption }}
        </span>
      </div>
    </template>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.openDebugMode {
  position: fixed;
  right: 0;
  bottom: 5px;
  padding: 3px;
  font-size: 12px;
  cursor: pointer;
  background-color: $primary-slate;
  border-radius: 16px;
  opacity: 0.5;
}

.debugModeWrapper {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999999;
  width: 100%;
  height: 100%;
  pointer-events: none;
  border: 2px solid $primary-blue;
}

.debugOptionsContainer {
  position: fixed;
  top: 0;
  z-index: 9999999;

  span {
    height: 30px;
    padding: 5px;
    color: $white;
    cursor: pointer;
    background-color: $primary-blue;
    border-right: 2px solid $secondary-green;

    &:hover {
      background-color: $primary-slate;
    }
  }
}
</style>
